export const italian = {
  hero: {
    title: 'Hoe Bistroo ons Italiaans restaurant hielp met de drukte en groei',
    description: 'Ristorante Il Municipio is een gerenommeerd Italiaans restaurant gevestigd in Twente, gespecialiseerd in authentieke pizza\'s en pasta\'s. Hun vakmanschap werd erkend toen ze in 2025 de 1ste plaats behaalden op het NK Pizzabakken op de Horecava.'
  },
  testimonials: {
    1: {
      text: '"Bistroo dacht echt met ons mee en bood oplossingen die aansloten bij onze behoeften en groeiende ambities. Nieuwe mogelijkheden werden snel uitgedacht en toegepast, wat zorgde voor een naadloze samenwerking en een verbetering van onze klantenservice"',
      name: 'Roberta',
      job_title: 'Gastvrouw'
    },
    2: {
      text: '"Met de overstap naar Bistroo hoeven we niet langer telefonische bestellingen aan te nemen, waardoor we kostbare tijd besparen en meer ruimte hebben voor de service aan onze klanten"',
      name: 'Edwin ter Haar',
      job_title: 'Eigenaar'
    }
  },
  challenge: {
    paragraph: {
      title: 'Nieuwe oplossing en mogelijkheden',
      text: 'Het restaurant staat bekend om zijn passie voor hoogwaardige ingrediënten en traditionele Italiaanse gerechten. Il Municipio werkt al ruim 2 jaar samen met Bistroo en vertelt kort over de uitdagingen die ze hadden vóór de samenwerking en de oplossingen die Bistroo biedt.'
    },
    paragraph_2: {
      title: 'De uitdaging',
      bullets: {
        1: 'Tijdens drukke uren kon Ristorante Il Municipio overweldigd raken door bestellingen, waardoor het restaurant personeel en klanten langer moest laten wachten.',
        2: 'Het opnemen van telefonische bestellingen vergde veel tijd van het personeel en leidde soms tot fouten of misverstanden.',
        3: 'Als een bedrijf dat snel verandert en groeit, had Ristorante Il Municipio behoefte aan een flexibele oplossing die kon meegroeien met hun evoluerende behoeften.',
        4: ''
      }
    }
  },
  solution: {
    title: 'De oplossing',
    checklist: {
      1: 'Bistroo\'s online besteloplossing bood Ristorante Il Municipio de mogelijkheid om klanten digitaal bevestigingen te sturen van hun bestellingen. Klanten konden hun bestellingen controleren op eventuele fouten, wat de nauwkeurigheid en tevredenheid verbeterde.',
      2: 'Door over te stappen op Bistroo hoefde het personeel van Ristorante Il Municipio niet langer telefonische bestellingen op te nemen, waardoor ze kostbare tijd besparen die ze kunnen besteden aan het bereiden van heerlijke gerechten en het bieden van uitstekende service aan klanten.',
      3: 'Bistroo dacht mee met Ristorante Il Municipio en bood oplossingen die aansloten bij hun veranderende behoeften en groeiende ambities. Nieuwe mogelijkheden werden snel uitgedacht en toegepast, wat zorgde voor een naadloze samenwerking en een betere klantenservice.',
      4: 'Bistroo staat altijd klaar om Ristorante Il Municipio te ondersteunen, ongeacht het tijdstip. Deze continue ondersteuning gaf het restaurant gemoedsrust en vertrouwen in hun online bestelproces.'
    }
  },
  conclusion: {
    title: 'De conclusie',
    text: {
      1: 'Dankzij Bistroo\'s Online Besteloplossing kon Ristorante Il Municipio niet alleen hun operationele efficiëntie verbeteren, maar ook hun klanttevredenheid verhogen en groeimogelijkheden benutten. Het restaurant waardeerde vooral het digitaal bevestigingssysteem en de tijdsbesparing die werd gerealiseerd door het elimineren van telefonische bestellingen.',
      2: 'Als partner die 24/7 beschikbaar is en meegaat met de behoeften van het restaurant, beveelt Ristorante Il Municipio Bistroo ten zeerste aan aan andere horecabedrijven die op zoek zijn naar een flexibele en efficiënte online besteloplossing.'
    }
  }
}